export default __webpack_public_path__ + "static/media/Add to package.1cd0c815.svg";